import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { CheckCircle, XCircle, Loader } from 'lucide-react'
import { verifyEmail } from '../api/auth'
import { AuthLayout } from '../components/layout/AuthLayout'

type State = 'loading' | 'success' | 'error'

export function VerifyEmail() {
  const { token } = useParams<{ token: string }>()
  const [state, setState] = useState<State>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) { setState('error'); setMessage('Missing verification token.'); return }

    verifyEmail(token)
      .then((res) => {
        setMessage(res.data.message)
        setState('success')
      })
      .catch((err) => {
        setMessage(err.response?.data?.error || 'Verification failed. The link may have expired.')
        setState('error')
      })
  }, [token])

  const title = state === 'loading' ? 'Verifying your email' : state === 'success' ? 'Email verified' : 'Verification failed'
  const subtitle = state === 'loading' ? 'Hang on a second…' : message

  return (
    <AuthLayout title={title} subtitle={subtitle}>
      {state === 'loading' && <Loader size={32} className="animate-spin text-gray-400" />}
      {state === 'success' && (
        <>
          <div className="mb-8 flex h-14 w-14 items-center justify-center rounded-full bg-success-50">
            <CheckCircle size={28} className="text-success-500" />
          </div>
          <Link to="/login" className="btn-primary w-full px-4 py-3">Go to login</Link>
        </>
      )}
      {state === 'error' && (
        <>
          <div className="mb-8 flex h-14 w-14 items-center justify-center rounded-full bg-error-50">
            <XCircle size={28} className="text-error-500" />
          </div>
          <Link to="/register" className="btn-primary w-full px-4 py-3">Back to registration</Link>
        </>
      )}
    </AuthLayout>
  )
}
